import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SessionService } from '../../app-lite/sessions/session.service';
import { VehicleModel }   from '../../app-lite/vehicles/models/vehicle';

@Component({
  template: require('./customer.vehicle.actions.component.html')
})
export class CustomerVehicleActionsComponent {
  @Input() record: VehicleModel;

  @Output() onAddVVGarageClick   : EventEmitter<VehicleModel> = new EventEmitter();
  @Output() onEditClick          : EventEmitter<VehicleModel> = new EventEmitter();
  @Output() onEventClick         : EventEmitter<VehicleModel> = new EventEmitter();
  @Output() onInvoiceClick       : EventEmitter<VehicleModel> = new EventEmitter();
  @Output() onRemoveVVGarageClick: EventEmitter<VehicleModel> = new EventEmitter();

  company = this.sessionService.company();
  session = this.sessionService.base();

  constructor (
    private sessionService: SessionService
  ) {}
}